interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  icon?: string;
  actionLabel?: string;
  actionTo?: string;
}

import { Link } from "react-router-dom";

export default function SectionHeading({
  title,
  subtitle,
  icon,
  actionLabel,
  actionTo,
}: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-5 md:mb-7">
      <div className="min-w-0">
        <h2 className="flex items-center gap-2 text-xl md:text-2xl font-heading font-bold text-foreground-950">
          {icon && (
            <span className="w-7 h-7 flex items-center justify-center text-accent-500">
              <i className={`${icon} text-xl`}></i>
            </span>
          )}
          {title}
        </h2>
        {subtitle && (
          <p className="mt-1.5 text-sm text-foreground-500">{subtitle}</p>
        )}
      </div>
      {actionLabel && actionTo && (
        <Link
          to={actionTo}
          className="shrink-0 whitespace-nowrap inline-flex items-center gap-1 text-sm text-foreground-600 hover:text-accent-600 transition-colors cursor-pointer"
        >
          {actionLabel}
          <i className="ri-arrow-right-s-line text-base"></i>
        </Link>
      )}
    </div>
  );
}